export enum ResponseItemPriority {
  P3 = 3,
  P4 = 4,
  P5 = 5
}
